"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useKnockDisplayName = require("./useKnockDisplayName");
Object.keys(_useKnockDisplayName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useKnockDisplayName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useKnockDisplayName[key];
    }
  });
});